module.exports = __webpack_public_path__ + "img/IPQC.beee747d.png";